import React from "react";
import { Button, Modal } from "antd";
import { MODAL_MESSAGES } from "../../../constants/messages";
import { BUTTON_TEXT, TEXT_CONSTANTS } from "../../../constants/Constants";
const NextButton = ({ isSaved, onClick,activeKey }) => {
  let flag=false

  if(activeKey=="Packaging"){
    flag=true;

  }
  const handleClick = () => {
    if (isSaved) {
      Modal.confirm({
        title: MODAL_MESSAGES.confirmNextPage.title,
        onOk() {
          onClick();
        },
      });
    } else {
      Modal.confirm({
        title: MODAL_MESSAGES.confirmNextPage.DataNotSavedtab,
        onOk() {
          onClick();
        },
      });
    }
  };

  return (
    <Button
      onClick={handleClick}
      style={{
        background: "#fff",
        border: "1px solid #004481",
        borderRadius: "25px",
        fontSize: "16px",
        fontWeight: 600,
        color:"#1F405A",
        padding: "8px 25px",
        transition: "background-color .3s, color .3s, border-color .3s"
      }}
      className={activeKey=="Packaging" ? "hidden":""}
      type="default"
      
    >
      {BUTTON_TEXT.NEXT}
    </Button>
  );
};

export default NextButton;
